import type { TFunction } from 'i18next';

import { Mobility } from './model/MobilityTypes';

export function mobilityTitle(t: TFunction, { type, year }: Pick<Mobility, 'type' | 'year'>) {
  const label = type == null ? t('mobilities.typeEnum.unspecified') : t(`travel.erasmusTypeEnum.${type}`);

  return `${label} ${year}`;
}
